import Analytics from '.';
import axios from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';
import { getDexToken } from '../get-tokens';
import { CourseModel } from '@descomplica/dex-models';
import { getCourseCategory } from '../category';

export interface PegasusError {
  response: {
    data: {
      identifier: string;
    };
  };
}

export interface PegasusErrorTrackingOptions {
  error: PegasusError;
  eventName: string;
  course?: CourseModel;
  trackingParams?: { [value: string]: any };
}

export class PostgradAnalytics extends Analytics {
  static async updateHubSpotContactProperties(
    properties: Record<string, string | number | boolean>,
  ): Promise<void> {
    const dexToken = getDexToken();

    await axios.put(
      '/hubspot/contacts',
      { properties: { ...properties, business_category: 'pos-graduacao' } },
      {
        baseURL: ENDPOINTS.pegasusMustang.ANALYTICS,
        headers: {
          'Authorization-Dex': `Bearer ${dexToken}`,
        },
      },
    );
  }

  static trackPegasusError({
    error,
    eventName,
    course,
    trackingParams = {},
  }: PegasusErrorTrackingOptions): void {
    const errorIdentifier = error.response?.data?.identifier ?? 'UnknownResponseError';

    this.trackEvent(eventName, {
      error_identifier: errorIdentifier,
      ...(course && { course: course.name, category: getCourseCategory(course) }),
      ...trackingParams,
    });
  }
}
